import { render } from "./MetaAdmin.vue?vue&type=template&id=c34978cc&scoped=true"
import script from "./MetaAdmin.vue?vue&type=script&lang=js"
export * from "./MetaAdmin.vue?vue&type=script&lang=js"

import "./MetaAdmin.vue?vue&type=style&index=0&id=c34978cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34978cc"]])

export default __exports__